import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatPrice',
  standalone: true,
})
export class FormatPricePipe implements PipeTransform {
  transform(
    value?: number | string | null,
    precision: number = 2,
    currencySymbol?: string
  ): string {
    const numericValue = typeof value === 'string' ? parseFloat(value) : (typeof value === 'number' ? value : NaN);

    const decimalPlaces = Math.max(
      0,
      Math.floor(typeof precision === 'number' && !isNaN(precision) ? precision : 2)
    );

    if (isNaN(numericValue)) {
      const defaultValue = (0).toFixed(decimalPlaces);
      return currencySymbol
        ? `${currencySymbol} ${defaultValue}`
        : defaultValue;
    }

    const formattedNumber = numericValue.toLocaleString('en-US', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    });

    if (currencySymbol) {
      return `${currencySymbol} ${formattedNumber}`;
    }

    return formattedNumber;
  }
}
